import { CustomerIcon, RestPinIconSelected } from './icons';
import React from 'react';
import { GMapReact } from './Maps';

export function CustomerInfoGMap(props) {

  const { customerLocation, restaurantAddress } = props;
  const markups = [
    {
      latLng: restaurantAddress,
      icon: <RestPinIconSelected />,
    },
  ];
  if (customerLocation) {
    markups.push({
      latLng: customerLocation,
      icon: <CustomerIcon />,
    });
  }
  return <GMapReact zoom={15} markups={markups} origin={restaurantAddress} />;
}